var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.3,
    d: "M19.123 7c.229 0 .425.155.483.37l.016.094.878 12.111c-.007 1.648-1.25 2.925-2.713 2.925H6.214c-1.464 0-2.707-1.277-2.714-2.925l.88-12.111A.5.5 0 0 1 4.877 7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.3,
    d: "M7.5 10c0-2.11-.61-8.328 4.5-8.328S16.5 7.859 16.5 10"
  })));
};
export default SvgCart;